import { FC, useContext } from 'react'
import { OutstandingBillsPayload } from '../../../../generated'
import { styled, Table, TableBody, TableHead, TableRow, TableCell, Box, Typography } from '@mui/material'
import { formatCurrency } from '../../../utils'
import { AuthContext } from '../../../context'
import palette from '../../../theme/palette'
import { Link } from 'react-router-dom'
import { format } from 'date-fns'

interface OutstandingBillsTableProps {
  outstandingBills: NonNullable<OutstandingBillsPayload['outstandingBills']>
}

const CustomTable = styled(Table)(({ theme }) => ({
  minWidth: '600px',
  border: '1px solid #E0E0E0',
  '& .MuiTableCell-root': {
    padding: theme.spacing(1),
    fontSize: '10px !important',
    backgroundColor: 'transparent'
  }
}))

const HeaderTypography = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1)
}))

const OutstandingBillsTable: FC<OutstandingBillsTableProps> = ({ outstandingBills }) => {
  const { isLoggedIn } = useContext(AuthContext)
  if (!outstandingBills?.length) return null

  return (
    <Box>
      <HeaderTypography variant="h6">Outstanding Invoices</HeaderTypography>

      <CustomTable>
        <TableHead>
          <TableRow>
            <TableCell width="8%">Invoice #</TableCell>
            <TableCell width="12%">Due Date</TableCell>
            <TableCell width="16%">Bill Amount</TableCell>
            <TableCell width="16%">Amount Paid</TableCell>
            <TableCell width="16%">Written Off</TableCell>
            <TableCell width="16%">Unpaid Balance</TableCell>
            <TableCell width="16%">Interest Accrued</TableCell>
            <TableCell width="16%">Total Outstanding</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {outstandingBills.map(bill => {
            const { billId, principalBalance, totalPayable, totalPaid, totalWrittenOff, interestDue, totalDue, clientId, dueDate } = bill

            return (
              <TableRow key={billId}>
                {isLoggedIn ? (
                  <TableCell>
                    <Link
                      to={`/billing/bill-detail/${billId}?clientId=${clientId}`}
                      style={{
                        color: palette.primary.main,
                        textDecoration: 'none'
                      }}
                    >
                      {billId}
                    </Link>
                  </TableCell>
                ) : (
                  <TableCell>{billId}</TableCell>
                )}
                <TableCell>{dueDate ? format(new Date(dueDate), 'MM/dd/yyyy') : ''}</TableCell>
                <TableCell>{formatCurrency(totalPayable)}</TableCell>
                <TableCell>{formatCurrency(totalPaid)}</TableCell>
                <TableCell>{formatCurrency(totalWrittenOff)}</TableCell>
                <TableCell>{formatCurrency(principalBalance)}</TableCell>
                <TableCell>{formatCurrency(interestDue)}</TableCell>
                <TableCell>{formatCurrency(totalDue)}</TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </CustomTable>

      <HeaderTypography variant="h6" sx={{ mt: 2 }}>
        Current Invoice
      </HeaderTypography>
    </Box>
  )
}

export default OutstandingBillsTable
